interface TagProps {
  children: string;
  tone?: "secondary" | "accent" | "primary";
}

const toneMap = {
  secondary: "bg-secondary-100 text-secondary-900",
  accent: "bg-accent-100 text-accent-900",
  primary: "bg-primary-100 text-primary-800",
};

export default function Tag({ children, tone = "secondary" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${toneMap[tone]}`}
    >
      {children}
    </span>
  );
}